module.exports = __webpack_public_path__ + "static/media/Portrait-10050.4e613ae5.jpg";